import React, { useEffect } from 'react';
import { DateTime } from 'luxon';
import { DatePicker, DatePickerProps, InputGroup } from 'rsuite';
import { utc_iana_time_zone_id } from '@/constants/time';

  const localToZoneToJsd = (date: Date|null, zone?: string) => {
    if(!date || !zone) return;

    const input = DateTime.fromJSDate(date);
    const zoned = DateTime.fromObject(
      {
        year: input.year,
        month: input.month,
        day: input.day,
        hour: input.hour,
        minute: input.minute,
      },
      { zone: zone }
    );
    return zoned.toJSDate();
  };

  const jsdToZoneToLocal = (date: Date|null, zone?: string) => {
    if(!date || !zone) return;

    //convert utc to zone date time
    const dtUtc = DateTime.fromJSDate(date, { zone: 'utc' });
    const zoneTime = dtUtc.setZone(zone);
    
    //get local zone Id
    const localZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    //convert zone date time to local date time
    const local = DateTime.fromObject(
      {
        year: zoneTime.year,
        month: zoneTime.month,
        day: zoneTime.day,
        hour: zoneTime.hour,
        minute: zoneTime.minute,
      },
      { zone: localZone }
    );

    return local.toJSDate();    
  };

type ZonedDatePickerProps = {
  value: Date|null; 
  zoneIanaId?: string;
  onChange?: (value: Date|null) => void;
} & Omit<DatePickerProps, "value" | "onChange">;;

const ZonedDatePicker: React.FC<ZonedDatePickerProps> = ({ 
  value, 
  zoneIanaId = utc_iana_time_zone_id, 
  onChange, 
  format = 'MM/dd/yyyy HH:mm',
  ...rest 
}) => {
    useEffect(() => { 
        if(!zoneIanaId){
            handleChange(null);
        }
    },[zoneIanaId]);

  const handleChange = (dt: Date|null) => {
    if (!format.includes('ss')) {
      dt?.setSeconds(0);
    }
    if (!format.includes('S') && !format.includes('SS') && !format.includes('SSS')) {
      dt?.setMilliseconds(0);
    }    
    if(onChange){
      onChange(zoneIanaId && dt ? localToZoneToJsd(dt, zoneIanaId) : null);
    }
  };

  return (
    <InputGroup>
     <div style={{ flex: 1 }}>
        <DatePicker
            {...rest}
            value={zoneIanaId && value ? jsdToZoneToLocal(value, zoneIanaId) : null}
            onChange={handleChange}
            format= {format}
        />
     </div>
      <InputGroup.Addon>
        {zoneIanaId ?? 'Specify Zone'}
      </InputGroup.Addon>
    </InputGroup>
    
  );
};

export default ZonedDatePicker;
